// extracted by mini-css-extract-plugin
module.exports = {"root":"Image_root__J8Wlz","lazy":"Image_lazy__1w_jB","loaded":"Image_loaded__3uNg2"};